export default __webpack_public_path__ + "881305570e42bc8af7c688040c638cf9.svg";